import React, { useState } from 'react';
import { colors, fonts } from '../theme/index.js';
import Text from './Text.js';
import Button from './Button.js';
import { useTheme } from '@mui/material/styles';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell/TableCell";
import TableBody from "@mui/material/TableBody";
import * as dates from "@simplybenefits/sb-dates";
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';
import * as localizationMaps from '../localization/maps.js';
import { Delete as TrashIcon } from '@mui/icons-material';

/**
 * @param {*} notes
 * @param allowNoteDeletion
 * @returns 
 */
function Notes({
  notes,
  allowRemoval,
  removeNote
}) {
  const [selectedNote, setSelectedNote] = useState(null);
  const theme = useTheme();

  /**
   * @param {*} note 
   */
  function _toggleNote(note) {
    if (note !== selectedNote) {
      setSelectedNote(note);
    } else {
      setSelectedNote(null);
    }
  }

  /**
   * @param {*} body 
   * @returns 
   */
  function _truncate(body) {
    if (body.length > 80) {
      return `${body.substring(0, 80)}...`;
    }
    return body;
  }
  const styles = {
    container: {
      flex: 1,
      border: "2px solid #F1F1F1",
      borderRadius: 5,
      backgroundColor: '#FFF',
      padding: 20
    },
    claimViewContainer: {
      flex: 1,
      backgroundColor: '#FFF',
      padding: 0
    },
    table: {
      display: 'block',
      overflowX: 'auto',
      paddingBottom: '20px',
      width: '100%',
      border: "2px solid #F1F1F1",
      backgroundColor: '#FFF'
    },
    scrollbar: {
      '&::webkitScrollbar': {
        height: '15px',
        width: '15px'
      },
      '&::webkitSrollbarThumb': {
        backgroundColor: colors.surface,
        borderRadius: '10px',
        boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
      },
      '&::webkitScrollbarTrack': {
        backgroundColor: colors.backgroundGrey,
        borderRadius: '10px',
        boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
      }
    },
    tableHeading: {
      paddingTop: "10px",
      paddingBottom: "10px",
      paddingRight: "2vw",
      paddingLeft: "2vw",
      fontFamily: fonts.type.heading,
      color: colors.surface,
      whiteSpace: "nowrap",
      border: "none"
    },
    tableCell: {
      paddingTop: "10px",
      paddingBottom: "10px",
      fontFamily: fonts.type.light,
      whiteSpace: "nowrap",
      paddingRight: "2vw",
      paddingLeft: "2vw",
      color: colors.mainTextGrey
    }
  };
  if (!notes || notes.length === 0) {
    return /*#__PURE__*/React.createElement(Text, {
      medium: true,
      color: colors.mainTextGrey
    }, i18n.t(tokens.labels.noNotesAvailable));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: "auto",
      maxHeight: 600,
      ...styles.scrollbar
    }
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
    sx: {
      backgroundColor: theme.palette.primary.main
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.note)), /*#__PURE__*/React.createElement(TableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.author)), /*#__PURE__*/React.createElement(TableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.created)), /*#__PURE__*/React.createElement(TableCell, {
    style: styles.tableHeading
  }))), /*#__PURE__*/React.createElement(TableBody, null, notes.map((note, index) => {
    let backgroundObject = {
      border: "none"
    };
    if (index % 2 !== 0) {
      backgroundObject = {
        backgroundColor: colors.backgroundGrey,
        border: "none"
      };
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      style: {
        ...styles.tableCell,
        ...backgroundObject
      }
    }, _truncate(note.body)), /*#__PURE__*/React.createElement(TableCell, {
      style: {
        ...styles.tableCell,
        ...backgroundObject
      }
    }, localizationMaps.fromEnglish("userType", note.createdBy)), /*#__PURE__*/React.createElement(TableCell, {
      style: {
        ...styles.tableCell,
        ...backgroundObject
      }
    }, dates.getLocalDisplay(note.dateAdded, 'lll', i18n.locale)), /*#__PURE__*/React.createElement(TableCell, {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        ...styles.tableCell,
        ...backgroundObject
      }
    }, /*#__PURE__*/React.createElement(Button, {
      transparent: true,
      onClick: () => _toggleNote(note)
    }, selectedNote?.noteID === note.noteID ? `${i18n.t(tokens.labels.hideFull)}` : `${i18n.t(tokens.labels.viewFull)}`), allowRemoval && /*#__PURE__*/React.createElement(Button, {
      transparent: true,
      onClick: () => removeNote(note.noteID)
    }, /*#__PURE__*/React.createElement(TrashIcon, null)))), selectedNote?.noteID === note.noteID && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      style: {
        ...styles.tableCell,
        ...backgroundObject
      },
      colSpan: 4
    }, /*#__PURE__*/React.createElement(Text, {
      formatted: true,
      bold: true
    }, note.body))));
  })))));
}
export default Notes;